import {AzureRegionResource} from "client/resources/azureRegionResource";
import client from "client/client";
import {CreateAzureRegionResource} from "client/resources/createAzureRegionResource";
import {
    AddRegionPublicIpPrefixRequest,
    ChangeRegionPublicIpPrefixAvailabilityRequest,
    ChangeRegionPublicIpPrefixPublicationRequest
} from "client/resources/regionPublicIpPrefixRequests";

export default class AzureRegionRepository {

    private rootUri = "/api/azure-regions";

    list(localPortalInstancesOnly?: boolean): Promise<AzureRegionResource[]> {
        return client.get(`${this.rootUri}{?localPortalInstancesOnly}`, {localPortalInstancesOnly});
    }

    async map(): Promise<Map<string, AzureRegionResource>> {
        const all = await this.list();
        return new Map<string, AzureRegionResource>(all.map<[string, AzureRegionResource]>(r => [r.Id, r]));
    }

    get(id: string): Promise<AzureRegionResource> {
        return client.get(`${this.rootUri}/{id}`, {id});
    }

    create(resource: CreateAzureRegionResource): Promise<AzureRegionResource> {
        return client.post(`${this.rootUri}`, resource);
    }

    reprovision(azureRegion: AzureRegionResource) {
        return client.put(`${this.rootUri}/{id}/reprovisioning`, {id: azureRegion.Id}, {id: azureRegion.Id});
    }

    addPublicIpPrefix(id: string, request: AddRegionPublicIpPrefixRequest): Promise<string> {
        return client.post(`${this.rootUri}/{id}/public-ip-prefixes`, request, {id});
    }

    deletePublicIpPrefix(id: string, name: string): Promise<string> {
        return client.del(`${this.rootUri}/{id}/public-ip-prefixes/{name}`, {args: {id, name}});
    }

    changePublicIpPrefixPublication(id: string, name: string, request: ChangeRegionPublicIpPrefixPublicationRequest) {
        return client.put(`${this.rootUri}/{id}/public-ip-prefixes/{name}/publication`, request, {id, name});
    }

    changePublicIpPrefixAvailability(id: string, name: string, request: ChangeRegionPublicIpPrefixAvailabilityRequest) {
        return client.put(`${this.rootUri}/{id}/public-ip-prefixes/{name}/availability`, request, {id, name});
    }

    republishStaticIpPrefixes(id: string): Promise<string> {
        return client.post(`${this.rootUri}/{id}/static-ip-prefix-publication`, {}, {id});
    }

    deleteE2eResources(name: string): Promise<string> {
        return client.del(`${this.rootUri}/e2e-resources/{name}`, {args: {name}});
    }
}
